$('[data-hover-id]').on('mouseenter', (e) => {
  const current = $(e.currentTarget)
  const id = current.data('hover-id')
  const image = $(`[data-hover-image="${id}"]`)

  current
    .addClass('is_active')
    .siblings()
    .removeClass('is_active')

  image
    .addClass('is_active')
    .siblings()
    .removeClass('is_active')
})
